// snake_case / camelCase -> Title Case for display. Used on Stripe metadata
// keys so the UI doesn't depend on whatever the billing runner stamps.

const OVERRIDES = {
  platform_enhancement_5_percent: 'Platform Enhancement (5%)',
  pre_increase_subtotal: 'Pre-Increase Subtotal',
  tax_basis_points: 'Tax Basis Points',
}

const WORD_OVERRIDES = {
  pi: 'PaymentIntent',
  url: 'URL',
  id: 'ID',
}

export function humanizeKey(key) {
  if (!key || typeof key !== 'string') return ''
  if (OVERRIDES[key]) return OVERRIDES[key]

  return key
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim()
    .split(' ')
    .filter(Boolean)
    .map((word) => {
      const lower = word.toLowerCase()
      if (WORD_OVERRIDES[lower]) return WORD_OVERRIDES[lower]
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')
}

export default humanizeKey
